<h1 mat-dialog-title>{{ 'TIMEOUT.DIALOG_TITLE'| translate }}</h1>
  <p> {{ 'TIMEOUT.TIMER_CONTENT'| translate }} {{display}} {{ 'TIMEOUT.SECONDS'| translate }}</p>

  <div mat-dialog-actions class="buttons">
    <button mat-raised-button (click)='logout()' class="single-button" color="primary" >{{ 'TIMEOUT.LOGOUT'| translate }}</button>
    <button mat-raised-button  color="primary" (click)='continue()' class="continue" class="single-button" > {{ 'TIMEOUT.CONTINUE'| translate }}</button>
  </div>